//
import { required, number } from "@/services/validations"

import HrPreviredCompensationFound from '@/models/HumanResource/HrPreviredCompensationFound'
//


//
//import StockAdjustDetailHeaders from "./headers"

//
export default [
    {
        name: "hr_previred_compensation_fund_id",
        type: "autocomplete-model",
        flex: {
            sm12: true,
            //lg3: true,
        },
        props: {
            itemText: "description",
            itemValue: "id",
            label: "Caja de Compensación.",
            loadingText: "Cargando Caja de Compensación...",
            model: HrPreviredCompensationFound,
            noDataText: "Sin Caja de Compensación.",
            noObject: true,
            rules: [required],
        },
    },
]
